// extracted by mini-css-extract-plugin
export default {"navBarMobile":"NavBarMobile-module__navBarMobile","navBarMobile__safeArea":"NavBarMobile-module__navBarMobile__safeArea"};